'use client';

import React from 'react';
import { ImageObj } from '@custom-types/ImageObj.types';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
type DynamicLogoProps = {
  logoImage?: string | ImageObj;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
};
export default function DynamicLogo({
  logoImage,
  alt = 'Brand logo',
  width = 203,
  height = 76,
  className = '',
  priority = false,
}: DynamicLogoProps) {
  const src = typeof logoImage === 'string' ? logoImage : logoImage?.url;
  const imageAlt = typeof logoImage === 'object' ? logoImage?.alt || alt : alt;
  if (!src) return null;
  return (
    <figure className={`${cn.brandLogo} ${className}`.trim()}>
      <CustomImage
        src={src}
        alt={imageAlt}
        width={width}
        height={height}
        priority={priority}
      />
    </figure>
  );
}
